import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  addNewReview: {
    id: 'reviews.addCard.addNewReview',
    description: 'Add new review',
    defaultMessage: 'Lisää uusi arviointi',
  },
  saveReview: {
    id: 'reviews.addCard.saveReview',
    description: 'Save review',
    defaultMessage: 'Tallenna arviointi',
  },
  rateCompany: {
    id: 'reviews.addCard.rateCompany',
    description: 'Rate company',
    defaultMessage: 'Arvioi yritys {companyName}',
  },
  thankForReviewing: {
    id: 'reviews.addCard.thankForReviewing',
    description: 'Thank for reviewing',
    defaultMessage: 'Kiitos arvioinnistasi!',
  },
  ratingLabelOverall: {
    id: 'reviews.addCard.ratingLabelOverall',
    description: 'Rating label for overall',
    defaultMessage: 'Yleisarvosana',
  },
  ratingLabelPrice: {
    id: 'reviews.addCard.ratingLabelPrice',
    description: 'Rating label for price',
    defaultMessage: 'Vastine rahalle!',
  },
  ratingLabelQuality: {
    id: 'reviews.addCard.ratingLabelQuality',
    description: 'Rating label for quality',
    defaultMessage: 'Laatuarvosana',
  },
  ratingLabelThumbs: {
    id: 'reviews.addCard.ratingLabelThumbs',
    description: 'Rating label for thumbs',
    defaultMessage: 'Palvelun sujuvuus',
  },
});
